
























































































import Enumerable from "linq";
import { Component, Mixins, Watch, Emit, Prop } from "vue-property-decorator";
import { StandardOption, MultiOptionSelectableMixin } from "./mixins";
import MultiListBoxSelector from "../../system/selectors/MultiListBoxSelector.vue";

@Component({
  components: {
    MultiListBoxSelector,
  },
})
export default class MultiOrderableOptionListBoxSelector extends Mixins(MultiOptionSelectableMixin) {
  @Prop()
  additionMaxCount: number;

  data(): any {
    return {
      selectingOptions: [],
      selectingSelectedOptions: [],
      selectableOptions: [],
      isFilteredOptionsSelectable: false,
    };
  }
  selectingOptions: StandardOption<any>[];
  selectingSelectedOptions: StandardOption<any>[];
  selectableOptions: StandardOption<any>[];
  isFilteredOptionsSelectable: boolean;

  // optionのclickイベントはIEでは動作しない...(chromeはイケた.)回避策として選択変更時に増えてる物をクリックされたと見なす.
  @Watch("selectingOptions")
  onSelectingOptionsChanged(newValue: StandardOption<any>[], oldValue: StandardOption<any>[]): void {
    this.notifyClicked(newValue, oldValue);
  }

  @Watch("selectingSelectedOptions")
  onSelectingSelectedOptions(newValue: StandardOption<any>[], oldValue: StandardOption<any>[]): void {
    this.notifyClicked(newValue, oldValue);
  }

  private notifyClicked(newValue: StandardOption<any>[], oldValue: StandardOption<any>[]): void {
    const clicked = Enumerable.from(newValue).firstOrDefault(o => (oldValue.indexOf(o) < 0));
    if (clicked) {
      this.clicked(clicked.value);
    }
  }

  @Emit()
  clicked(clicked: any): void {}

  @Emit()
  filteredOptionsChanged(filteredOptions: StandardOption<any>[]): void {}

  get unselectedOptions(): StandardOption<any>[] {
    return Enumerable.from(this.options)
      .where(o => !this.contains(this.selectedOptions, o))
      .toArray();
  }

  get hasSelectingOptions(): boolean {
    return (0 < this.selectingOptions.length);
  }

  get hasSelectingSelectedOptions(): boolean {
    return (0 < this.selectingSelectedOptions.length);
  }

  get hasSelectedOptions(): boolean {
    return (0 < this.selectedOptions.length);
  }

  get isMovableToPrevious(): boolean {
    return this.isMovable(-1);
  }

  get isMovableToPost(): boolean {
    return this.isMovable(1);
  }

  get selectableOptionsCount(): number {
    return this.selectableOptions ? this.selectableOptions.length : 0;
  }

  areOptionsEqual(source: StandardOption<any>, destination: StandardOption<any>): boolean {
    return (source === destination)
        || (source && destination && this.areEqual(source.value, destination.value));
  }

  addSelection(): void {
    this.selectedOptions = this.distinct(this.selectedOptions.concat(this.selectingOptions));
    this.selectingOptions = [];
  }

  addAllOptions(): void {
    if (this.additionMaxCount && (this.selectableOptionsCount > this.additionMaxCount)) {
      this.$warn("選択対象確認", "対象が多すぎます。" + this.additionMaxCount + "件以下にしてください。");
      return;
    }
    this.selectedOptions = this.distinct(this.selectedOptions.concat(this.selectableOptions));
  }

  removeSelection(): void {
    this.selectedOptions = Enumerable.from(this.selectedOptions)
      .where(o => !this.contains(this.selectingSelectedOptions, o))
      .toArray();
    this.selectingSelectedOptions = [];
  }

  removeAllOptions(): void {
    this.selectedOptions = [];
  }

  isMovable(amount: number): boolean {
    return (this.adjustAmount(amount, this.selectingSelectedOptions, this.selectedOptions) !== 0);
  }

  moveSelection(amount: number): void {
    // 先にループを回してindexがはみ出さないようamountを調整しておく.
    const adjustedAmount = this.adjustAmount(amount, this.selectingSelectedOptions, this.selectedOptions);
    const results = this.selectedOptions.concat();
    const selecting = this.selectingSelectedOptions.concat();
    // 向きによって処理順を変える.(追い抜きによってずれるのを防ぐため.)
    Enumerable.from((0 < adjustedAmount) ? selecting.reverse() : selecting)
      .forEach(o => {
        const index = Enumerable.from(results).indexOf(s => this.areOptionsEqual(s, o));
        results.splice(index, 1);
        results.splice(index + adjustedAmount, 0, o);
      });
    this.selectedOptions = results;
  }

  adjustAmount(amount: number, selecting: StandardOption<any>[], selected: StandardOption<any>[]): number {
    if ((selecting.length <= 0) || (selected.length <= 0)) {
      return 0;
    }
    const indexes = Enumerable.from(selecting)
      .select(o => Enumerable.from(selected).indexOf(s => this.areOptionsEqual(s, o)))
      .toArray();
    const min = Enumerable.from(indexes).min();
    const max = Enumerable.from(indexes).max();
    return ((min + amount) < 0)
      ? -min
      : ((selected.length <= (max + amount)) ? (amount - (selected.length - max)) : amount);
  }

  // linq.jsのdistinct使いたかったが、ユニークキーを返す式を指定しなくてはならないので、現状のequivalent-validatorでは対応困難.冗長だけど頑張る.
  private distinct(source: StandardOption<any>[]): StandardOption<any>[] {
    const results = [] as StandardOption<any>[];
    for (const o of source) {
      if (!this.contains(results, o)) {
        results.splice(results.length, 0, o);
      }
    }
    return results;
  }

  // linq.jsのcontains使いたかったが、ユニークキーを返す式を指定しなくてはならないので、現状のequivalent-validatorでは対応困難.冗長だけど頑張る.
  private contains(options: StandardOption<any>[], option: StandardOption<any>): boolean {
    for (const o of options) {
      if (this.areOptionsEqual(o, option)) {
        return true;
      }
    }
    return false;
  }

  onLoadedOptionsUpdated(loadedOptions: any[]): void {
    this.isFilteredOptionsSelectable = (loadedOptions.length > 0);
  }

  onFilteredOptionsChanged(filteredOptions: any[]): void {
    this.selectableOptions = filteredOptions;
    this.filteredOptionsChanged(filteredOptions);
  }
}
